import React from 'react'
import imageNotFound from "../../assets/Illustrations/findintelescope.png"

const index = () => {
  return (
    <div className="min-h-[600px] flex-1 flex flex-col items-center pt-10 justify-start">
    <img src={imageNotFound} alt="not found" className="w-60 object-cover"/>
    <p className= "text-3xl font-semibold">Auccun Résultat</p>
    <p className= "text-lg ">Nous avons trouvé aucun données correspondant à vos critères.</p>
  </div>
  )
}

export default index